import { useState } from "react";
import styles from "./Choice.module.css"
import { Spin } from "antd";

function Choice({ props }) {
    const [statusButton, setStatusButton] = useState(false);

    return (
        <div className={styles.main}>
            <div className={styles.text}>
                {props.text}
            </div>
            <div className={styles.containerButtons}>
                {statusButton ? <Spin /> : (
                    <>
                        <button onClick={async () => { setStatusButton(true); await props.handleClick(props.type) }}>Подтвердить</button>
                        <button onClick={props.handleClose} style={{ background: "#bd1b1b" }}>Отмена</button>
                    </>
                )}

            </div>
        </div>
    )

}

export default Choice;